module.exports = __webpack_public_path__ + "static/media/user.18c1e962.svg";